"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdateEffect = void 0;
var _react = require("react");
/**
 * Equivalent to `useEffect` but skips initial mount
 */
var useUpdateEffect = function useUpdateEffect(effect, deps) {
  var didMountRef = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    if (didMountRef.current) {
      return effect();
    }
    didMountRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
exports.useUpdateEffect = useUpdateEffect;
//# sourceMappingURL=useUpdateEffect.js.map